export enum CompanyContextEnum {
  AmericanCompany = "AmericanCompany",
  BrazilianCompany = "BrazilianCompany",
  FIIs = "RealEstateFund",
}

export enum CompanyMenuSlugEnum {
  ABOUT = "ABOUT_BOX",
  CARDS = "CARDS",
  GOVERNANCE = "GOVERNANCE_BOX",
  LIQUIDITY = "LIQUIDITY_BOX",
  OPERATING_SEGMENTS = "OPERATING_SEGMENTS_BOX",
  FINANCIALS = "FINANCIALS_BOX",
  KPIS = "KPIS_BOX",
  QUOTES = "QUOTES_BOX",
  VALUATION = "VALUATION_BOX",
  EVENTS = "EVENTS_BOX",
  DISCUSSIONS = "DISCUSSIONS_BOX",
  SETTINGS = "SETTINGS_BOX",
  HIGHLIGHTS = "HIGHLIGHTS_BOX",

  // Real Estate Fund
  ASSETS = "ASSETS_BOX",
}

export enum CompanyAboutTabEnum {
  ABOUT = "ABOUT",
  HISTORY = "HISTORY",
  RISK_FACTORS = "RISK_FACTORS",

  // Real Estate Fund
  COMPENSATION_POLICY = "COMPENSATION_POLICY",

  // Brazilian Company
  SUBSIDIARIES = "SUBSIDIARIES",
}

export enum CompanyGovernanceTabEnum {
  EQUITY_POSITION = "EQUITY_POSITION",
  EXECUTIVE = "EXECUTIVE",
  COMPENSATION = "COMPENSATION",
  EMPLOYEES = "EMPLOYEES",
  RECLAME_AQUI = "RECLAME_AQUI",

  // American Company
  SAY_ON_PAY = "SAY_ON_PAY",
  CEO_PAY_RATIO = "CEO_PAY_RATIO",

  // Brazilian Company
  FREE_FLOAT = "FREE_FLOAT",
}

export enum CompanyLiquidityTabEnum {
  TRADE_HISTORY = "TRADE_HISTORY",
  SHARES_OUTSTANDING = "SHARES_OUTSTANDING",
  FREE_FLOAT = "FREE_FLOAT",
  SHARES_HOLDERS = "SHARES_HOLDERS",
}

export enum CompanyOperatingSegmentsTabEnum {
  BUSINESS = "BUSINESS",
  GEOGRAPHIC = "GEOGRAPHIC",
}

export enum CompanyFinancialsTabEnum {
  FINANCIALS = "FINANCIALS",
  FINANCIALS_CHART = "FINANCIALS_CHART",
  KPIS = "KPIS",
  COMPARE = "COMPARE",
}

export enum KpisTabEnum {
  TABLE = "TABLE",
  CHART = "CHART",
  DOCUMENTATION = "DOCUMENTATION",
}

export enum CompanyQuotesTabEnum {
  QUOTE = "QUOTE",
  HISTORICAL_RETURN = "HISTORICAL_RETURN",
  PRICE_VS_INDICATOR = "PRICE_VS_INDICATOR",
  MARKET_CAPITALIZATION = "MARKET_CAPITALIZATION",
}

export enum CompanyEventsTabEnum {
  RELEASES = "RELEASES",
  CALENDAR = "CALENDAR",
  DIVIDENDS = "DIVIDENDS",
  STOCK_DIVIDENDS = "STOCK_DIVIDENDS",
  RIGHTS_ISSUES = "RIGHTS_ISSUES",
  STOCK_SPLIT = "STOCK_SPLIT",
}

export enum CompanyDiscussionsTabEnum {
  COMMENTS = "COMMENTS",
  FAQ = "FAQ",
}

export enum CompanyAssetsTabEnum {
  DISTRIBUTION = "DISTRIBUTION",
  QUOTA = "QUOTA",
}

export enum CompanyHighlightsTabEnum {
  HIGHLIGHTS = "HIGHLIGHTS",
  VIDEOS = "VIDEOS",
}
